<template>

<div>

	<!-- show loading indicator -->
	<loading-indicator :loading="isLoading"></loading-indicator>

	<template v-if="!isLoading">

		<!-- page-heading -->
		<page-heading :show="true" :pageTitle="title"></page-heading>

		<div class="columns">

			<div class="col-main">

                <div class="box">

                    <form-input inputType="text" label="ECS-CATEGORY_NAME" inputSize="is-medium" v-model="equipmentCatalogSection.name" :isHorizontal="true"></form-input>
					<form-input inputType="text" label="ECS-CATEGORY_COLOR" inputSize="is-medium" v-model="equipmentCatalogSection.color" :isHorizontal="true"></form-input>

					<!--
					<pre>
						{{ equipmentCatalogSection }}
					</pre>
					-->


					<div class="control is-horizontal">

						<div class="control-label">
							<label-name labelKey="ECS-UPLOAD-TEMPLATE"></label-name>
						</div>

						<div class="control">

							<vue-dropzone
								ref="template"
								id="vueDropzoneGeneral"
								url= "fileProcessing/upload?preset=equipmentCatalog"
								:thumbnailWidth="145"
								:thumbnailHeight="67"
								:maxFiles="1"
								acceptedFiles= ".jpg,.pdf"
								:dictDefaultMessage="`<i class='fa fa-cloud-upload'></i> ` + $t('ECS-UPLOAD-TEMPLATE')"
								v-on:vdropzone-removed-file="dzRemove('template')"
								v-on:vdropzone-mounted="dzInit('template')"
								v-on:vdropzone-success="dzSuccess($event, 'template')"
								dzClass="dzSingle">

							</vue-dropzone>

						</div>

					</div>

					<div class="control is-horizontal">

						<div class="control-label">
							<label-name labelKey="ECS-UPLOAD-INTRO_TEMPLATE"></label-name>
						</div>

						<div class="control">

							<vue-dropzone
								ref="introTemplate"
								id="vueDropzoneIntro"
								url= "fileProcessing/upload?preset=equipmentCatalog"
								:thumbnailWidth="145"
								:thumbnailHeight="67"
								:maxFiles="1"
								acceptedFiles= ".jpg,.pdf"
								:dictDefaultMessage="`<i class='fa fa-cloud-upload'></i> ` + $t('ECS-UPLOAD-INTRO_TEMPLATE')"
								v-on:vdropzone-removed-file="dzRemove('introTemplate')"
								v-on:vdropzone-mounted="dzInit('introTemplate')"
								v-on:vdropzone-success="dzSuccess($event, 'introTemplate')"
								dzClass="dzSingle">

							</vue-dropzone>

						</div>

					</div>


					<div class="control is-horizontal">

						<div class="control-label">
							<label-name labelKey="ECS-UPLOAD-LEFT_TEMPLATE"></label-name>
						</div>

						<div class="control">

							<vue-dropzone
								ref="leftPageTemplate"
								id="vueDropzoneLeft"
								url= "fileProcessing/upload?preset=equipmentCatalog"
								:thumbnailWidth="145"
								:thumbnailHeight="67"
								:maxFiles="1"
								acceptedFiles= ".jpg,.pdf"
								:dictDefaultMessage="`<i class='fa fa-cloud-upload'></i> ` + $t('ECS-UPLOAD-LEFT_TEMPLATE')"
								v-on:vdropzone-removed-file="dzRemove('leftPageTemplate')"
								v-on:vdropzone-mounted="dzInit('leftPageTemplate')"
								v-on:vdropzone-success="dzSuccess($event, 'leftPageTemplate')"
								dzClass="dzSingle">

							</vue-dropzone>

						</div>

					</div>

                </div>

			</div>

	        <div class="col-aside">

				<affix :offset="50">

		            <div class="sidebox">
						<custom-button type="blue" icon="icon-ak-speichern" name="ECS-BTN-SAVE" :loading="isSaving" @click.native="submitForm()" :class="{'is-disabled': isReadOnly}"></custom-button>
					</div>

				</affix>

	        </div>

	    </div>

	</template>

</div>
</template>



<script>
import vueDropzone from '../utils/dropzoneWrapper';

export default {

    name: 'equipmentCatalogSection',

	components: {
		vueDropzone
	},

	data() {

		return {
			equipmentCatalogSection: null,
			isNewEquipmentCatalogSection: false,
			isSaving: false,
			isLoading: false,
		}
	},


	created() {

		// existing category - fetch the category ID from router
		if(this.$route.params.equipmentCatalogSectionID && Number.isInteger(parseInt(this.$route.params.equipmentCatalogSectionID)) ) {

			this.fetchData();

		}

		// new category
		else {

			this.isNewEquipmentCatalogSection = true;

			// create new equipment obj with default values
			this.equipmentCatalogSection = {
			    name: "",
			}

		}

	},

    computed: {

        title() {

            if(this.isNewEquipmentCatalogSection == true) {
                return 'ECS-HEADER-NEW_SECTION';
            } else {
                return this.equipmentCatalogSection.name;
            }
        },
    },

	mounted() {

	},


	update() {

	},


	methods: {


		dzSuccess(file, type) {


			/*
			var result = JSON.parse(file.xhr.response);

            this.equipmentCatalog.cover = {
				filename: result.fileName,
				path: result.dir,
				uploadFilename: file.name
			}

			// set the url
			var filename = this.equipmentCatalog.cover.filename.substr(0, this.equipmentCatalog.cover.filename.lastIndexOf(".")) + ".jpg"
			let url = this.$config.assets + this.equipmentCatalog.cover.path + '/thumb/' + filename;
			var mockFile = { id: 'ecCover', name: filename }

			// add mockFile to our dropzone
			this.$refs.vueDropzoneGeneral.$children[0].manuallyAddFile(mockFile, url);

			// this.saveCover( { isSilent: false, msg: 'EC-MSG-COVER_SUCCESSFULLY_UPLOADED' } );
			*/

		},


		dzInit(type) {


            if(this.equipmentCatalogSection[type] != null) {

				var filename = this.equipmentCatalogSection[type].filename.split('.').pop() == 'pdf'
					? this.equipmentCatalogSection[type].filename.substr(0, this.equipmentCatalogSection[type].filename.lastIndexOf(".")) + ".jpg"
					: this.equipmentCatalogSection[type].filename;

                // set the url
                let url = this.$config.assets + this.equipmentCatalogSection[type].path + '/thumb/' + filename;

				// console.log(url);

                var mockFile = { id: type, name: filename, type: "image/*", size: 123 }

                // add mockFile to our dropzone
                this.$refs[type].$children[0].manuallyAddFile(mockFile, url);

            }


		},

		dzSuccess(file, type) {


			this.$refs[type].$children[0].removeAllFiles();

			var result = JSON.parse(file.xhr.response);

            this.equipmentCatalogSection[type] = {
				filename: result.fileName,
				path: result.dir,
				uploadFilename: file.name
			}

			let filename = this.equipmentCatalogSection[type].filename.substr(0, this.equipmentCatalogSection[type].filename.lastIndexOf(".")) + ".jpg"
			let url = this.$config.assets + this.equipmentCatalogSection[type].path + '/thumb/' + filename;

			let mockFile = { id: type, name: filename, type: "image/*", size: 123 }

			// add mockFile to our dropzone
			this.$refs[type].$children[0].manuallyAddFile(mockFile, url);

            // this.saveCatalog( { isSilent: true } );

		},

		dzRemove(type) {

			// console.log("TYP: ", type);

            this.equipmentCatalogSection[type] = null;

            // this.saveCatalog( { isSilent: true } );

		},


		fetchData() {

			this.isLoading = true;
			var self = this;

            this.axios.get(self.$config.api + 'equipmentCatalogSection/' + this.$route.params.equipmentCatalogSectionID + '?include=equipmentCatalogSection.template,equipmentCatalogSection.introTemplate,equipmentCatalogSection.leftPageTemplate')
				.then(function(response) {

					// console.log(response.data);
                    self.equipmentCatalogSection = response.data;
                    self.isLoading = false;

				}).catch(function(error) {
                    self.isLoading = false;
					console.log('Error: ', error.message);
				});

		},

		submitForm() {

            //this.isSaving = true;
			//var self = this;

			this.entityCreateOrUpdate('equipmentCatalogSection', this.equipmentCatalogSection, { msg: 'ECS-MSG-SUCCESSFULLY_SAVED' })
				.then(function(response) {

				});


			/*
            this.axios.post(self.$config.api + 'equipmentCatalogSection/', self.equipmentCatalogSection)
				.then(function(response) {

                    self.isSaving = false;
                    self.$notify.success({content: self.$t('MSG-SUCCESS-DATA_SAVE')});

				}).catch(function(error) {

					self.isSaving = false;
					self.$notify.open({content: self.$t('MSG-ERROR-DATA_SAVE') + ': ' + error.message, type: 'danger'});

				});
				*/


		}

	}

}

</script>


<style>

</style>
